module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n9n2r5r-e4a22cfb865c9519882d11d1a59c98e7.svg";